import React from 'react';
import './headerLanding.css'

import { Layout} from 'antd';
const { Header } = Layout;

const HeaderLanding = () => {

    return <Header className='headerLanding'>
        <div className="logo">
            <img src='/talentha-blanco.png' alt='Logo Talentha' />
        </div>
        <div className="navbar-menu">
        </div>
    </Header>
}

export default HeaderLanding;